<template>
    <transition name="fade">
        <div class="preloader-offer">
            <div class="img">
                <img src="/img/icon/preloader.gif" alt="">
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Preloader-offer",
    }
</script>